const LightPrimaryButtonFull = ({ text }: { text: string }) => {
  return (
    <button className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-red-600 hover:text-red-700 bg-red-200 hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-200">
      {text}
    </button>
  );
};

export default LightPrimaryButtonFull;
